import React, { useState, useEffect } from 'react';
import './quote-detail.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import Popup from '../popup/Popup';
import '../popup/popup.scss';
import { decodeLineBreak } from '../../functions/HTMLDecode';
import { IsWebReference } from '../../functions/Configuration';
import { useIsMobile } from '../../functions/Theme';

export default function QuoteDetail(props: any) {

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const config = JSON.parse(localStorage.getItem('siteConfig') || "{}");
    const isMobile = useIsMobile();

    function disableScrolling() {
        var x = window.scrollX;
        var y = window.scrollY;
        window.onscroll = function () { window.scrollTo(x, y); };
    }

    function enableScrolling() {
        window.onscroll = function () { };
    }

    const togglePopup = () => {
        if (!isPopupOpen) {
            disableScrolling();
        } else {
            enableScrolling();
        }

        setIsPopupOpen(!isPopupOpen);
    }

    const documentExists = (path: any) => {
        try {
            require(`../../${path}`);
            return true;
        } catch (err) {
            return false;
        }
    };

    const getBreakdownItems = (descriptionStart: string, descriptionEnd: string) => {
        let breakdownItems: any[] = [];
        let inAddRange = false;
        props.quote.quote.breakdownsField.forEach((breakdown: any) => {
            if (breakdown.descriptionField === descriptionStart) {
                inAddRange = true;
            }
            if (inAddRange) {
                breakdownItems.push(breakdown);
            }

            if (inAddRange && breakdown.descriptionField === descriptionEnd) {
                inAddRange = false;
            }
        });

        return breakdownItems;
    }

    return (
        <div className="quote-detail">
            <p className="reference-number">Reference number: {props.policyNumber}</p>
            <div className="quote-insurer-row">
                <p className="quote-insurer">Insurer</p>
                <p className="detail-value quote-insurer-name">{props.quote.insurerName}</p>
            </div>
            <p className="detail-header">Sums insured</p>
            {props.quote.premCovers.map((premCover: any, index: number) => (
                <div key={"sums_" + index} className="quote-detail-row">
                    <span className="text-with-breaks">
                        {premCover.coverName}
                    </span>
                    <span className="detail-value text-with-breaks">
                        {decodeLineBreak (premCover.coverValue)}
                    </span>
                </div>
            ))}
                <p className="detail-header">Excess</p>

                {props.quote.quote.excessesField != null && props.quote.quote.excessesField.map((excess: any, index: number) => {

                    return (<div key={"excess_" + index} className="quote-detail-row">
                        <span>{excess.descriptionField}</span>
                        {(excess.descriptionField !== "Frozen Foods" || !IsWebReference("SI")) &&
                            <span className="detail-value">&pound;{decodeLineBreak(excess.amountField)}</span>
                        }
                        {(excess.descriptionField === "Frozen Foods" && IsWebReference("SI")) &&
                            <span className="detail-value">{decodeLineBreak(excess.amountField)}%</span>
                        }

                    </div>)
                })}

            <p className="detail-header">Important documents</p>
            <p>Limitations and Exclusions may apply. Please read the document below for details</p>

            {documentExists(props.quote.policySummaryPath) &&
                <a type="button"
                    className="quote-document"
                    href={require(`../../${props.quote.policySummaryPath}`)}
                    target="_blank"
                    rel="noreferrer">
                    Policy Summary <FontAwesomeIcon icon={faFileLines} />
                </a>
            }

            {documentExists(props.quote.policyWordingPath) &&
                <a type="button"
                    className="quote-document"
                    href={require(`../../${props.quote.policyWordingPath}`)}
                    target="_blank"
                    rel="noreferrer">
                    Policy Wording <FontAwesomeIcon icon={faFileLines} />
                </a>
            }

            <a type="button"
                className="quote-document"
                href={`https://www.${config.baseLinkUrl}/terms-of-business`}
                target="_blank"
                rel="noreferrer">
                Terms of Business <FontAwesomeIcon icon={faFileLines} />
            </a>

            <span className="quote-document" onClick={() => togglePopup()}>Limitations & Exclusions <FontAwesomeIcon icon={faFileLines} /></span>

            {isPopupOpen && <Popup
                content={<>
                    <h1>Limitations & Exclusions</h1>
                    {props.quote.quote.endorsementsField != null && props.quote.quote.endorsementsField.length > 0 &&
                        props.quote.quote.endorsementsField.map((endorsement: any, index: number) => {

                            return (<div key={"endorsement_" + index} className="endorsement">
                                <p className="endorsement-title">{endorsement.codeField}-{endorsement.titleField}</p>
                                <p>{decodeLineBreak (endorsement.fullWordingField)}</p>
                            </div>)
                        })}
                    {(props.quote.quote.endorsementsField == null || props.quote.quote.endorsementsField.length === 0) &&
                        <p>No Limitations & Exclusions to display</p>}
                </>}
                handleClose={togglePopup}
            />}

            <p className="detail-header">Premium breakdown</p>
            {props.quote.premCovers.map((premCover: any, index: number) => {

                return (<div key={"sums_" + props.quote.insurerName + "_" + index} className="quote-detail-row">
                    <span>{premCover.coverName}</span>
                    <span className="detail-value">{decodeLineBreak (premCover.premiumValue)}</span>
                </div>)
            })}

            {IsWebReference("SI") &&
                <div>
                    {getBreakdownItems("Stocks", "Subtotal").map((breakdown: any, index: number) => {

                        return (<div key={"stock_" + props.quote.insurerName + "_" + index} className="quote-detail-row">
                            <span>{breakdown.descriptionField}</span>
                            <span className="detail-value">
                                {breakdown.runningTotalField !== "" && <>&pound;</> }
                                {decodeLineBreak(breakdown.runningTotalField)}</span>
                        </div>)
                    })}

                    {getBreakdownItems("Specified Business Equipment", "Subtotal").map((breakdown: any, index: number) => {

                        return (<div key={"sbe_" + props.quote.insurerName + "_" + index} className="quote-detail-row">
                            <span>{breakdown.descriptionField}</span>
                            <span className="detail-value">
                                {breakdown.runningTotalField !== "" && <>&pound;</>}
                                {decodeLineBreak(breakdown.runningTotalField)}</span>
                        </div>)
                    })}
                </div>
            }

            <p className="detail-header">How you pay</p>
            {props.payAnnual &&
                <div className="quote-detail-row">
                    <span>Annual Premium <small>(including IPT at the appropriate rate)</small></span>
                    <span className="detail-value">&pound;{parseFloat(props.quote.quote.grossPremiumField.toString()).toFixed(2)}</span>
                </div>
            }
            {!props.payAnnual &&
                <>
                    <div className="quote-detail-row">
                        <span>Annual Premium <small>(including IPT at the appropriate rate)</small></span>
                        <span className="detail-value">&pound;{parseFloat(props.quote.annualPremium.toString()).toFixed(2)}</span>
                    </div>
                    <div className="quote-detail-row">
                        <span>Deposit required</span>
                        <span className="detail-value">&pound;{parseFloat(props.quote.monthlyDeposit.toString()).toFixed(2)}</span>
                    </div>
                    <div className="quote-detail-row">
                        <span>Charge for credit (
                            {props.quote.jsonItem[0].aprInfo.details} on remaining balance)</span>
                        <span className="detail-value">&pound;{(Math.round((props.quote.totalDebt - props.quote.annualPremium) * 100) / 100).toFixed(2)}</span>
                    </div>
                    <div className="quote-detail-row">
                        <span>First instalment payment</span>
                        <span className="detail-value">&pound;{parseFloat(props.quote.monthlyFirstInstalment.toString()).toFixed(2)}</span>
                    </div>
                    <div className="quote-detail-row">
                        <span>{props.quote.monthlyPaymentsCount} instalment payments</span>
                        <span className="detail-value">&pound;{parseFloat(props.quote.monthlyPayment.toString()).toFixed(2)}</span>
                    </div>
                    <div className="quote-detail-row">
                        <span>Total Payable</span>
                        <span className="detail-value">&pound;{parseFloat(props.quote.totalDebt.toString()).toFixed(2)}</span>
                    </div>
                </>
            }
        </div>
    )
}